import React from 'react'
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography, TextField } from '@mui/material'

import { TripalinkResidentStepProps } from '../types'

const TripalinkResidentStep: React.FC<TripalinkResidentStepProps> = ({
  value,
  onChange,
  error,
  apartmentInfo,
  onApartmentInfoChange,
  apartmentInfoError,
}) => {
  const options = ['Yes', 'No']

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        Are you a Tripalink resident?
      </Typography>

      <FormControl error={error}>
        <RadioGroup value={value} onChange={e => onChange(e.target.value)} className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} className="text-base" />
          ))}
        </RadioGroup>
        {error && <FormHelperText>This question is required</FormHelperText>}
      </FormControl>

      {value === 'Yes' && (
        <Box className="flex flex-col gap-4">
          <Typography variant="h6" className="font-semibold text-gray-900">
            If yes, what is your apartment name or address?
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Your answer (optional)"
            value={apartmentInfo}
            onChange={e => onApartmentInfoChange(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              },
            }}
          />
        </Box>
      )}
    </Box>
  )
}

export default TripalinkResidentStep
